import React, { useEffect } from 'react';
import { AppError, AppLayoutBlank, Button, Icon, Title } from '@mc/ui-v4';
import { BugController, SpiderController } from '../bugs/bug';
import { startSprout } from '../bugs/sprout';
import { startRope } from '../bugs/rope';
import { mcRefresh } from '@mc/react-ui-icons';

type Props = {
  message: string;
  description?: string;
};

export const AppErrorPage: React.FC<Props> = ({
  message,
  description,
  children,
}) => {
  useEffect(() => {
    if (__DEV__) {
      // @ts-ignore
      const we: string[] = window.__ERR_EFFECTS__;

      const effects = we === undefined ? ['rope', 'bugs', 'sprout'] : we;
      let count = effects.length;
      if (count > 0) {
        let type = Math.floor(Math.random() * count);
        let effect = effects[type];

        switch (effect) {
          case 'rope':
            startRope();
            break;
          case 'bugs':
            // @ts-ignore
            new BugController({});

            // default spiders:
            // @ts-ignore
            new SpiderController({});
            break;
          case 'sprout':
            startSprout();
            break;
        }
      }
    }
  }, []);

  if (__DEV__) {
    return (
      <AppLayoutBlank>
        <AppError noCenter message={message} className={'m-4'}>
          <Button
            className={'mt-2'}
            style={'primary'}
            onClick={() => window.location.reload()}
            icon={<Icon icon={mcRefresh} />}
          >
            Načíst znovu
          </Button>
          <div className={'mt-2'}>
            {description && <Title type={'pageBlock'}>{description}</Title>}
            <div className={'mt-1'}>{children}</div>
          </div>
          <canvas
            id="myCanvas"
            width={600}
            height={400}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              pointerEvents: 'none',
            }}
          ></canvas>
        </AppError>
      </AppLayoutBlank>
    );
  } else {
    return (
      <AppLayoutBlank horizontalCenter verticalCenter>
        <AppError message={message}>
          <Button
            className={'mt-2'}
            style={'primary'}
            onClick={() => window.location.reload()}
            icon={<Icon icon={mcRefresh} />}
          >
            Načíst znovu
          </Button>
        </AppError>
      </AppLayoutBlank>
    );
  }
};
